/* eslint-disable complexity */
// oxlint-disable max-lines-per-function
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { TiiaAuthService } from '../auth.service';
import { TiiaService } from '../tiia.service';

import type { CanActivateFn } from '@angular/router';

let init = true;

/**
 * It accepts every path if these conditions are not met:
 * - 5th step is accepted only on first enter, because otherwise we will redirect user to the root page
 * - 3rd step is accepted only on the way forward, not backward, because we don't want to change finished agreement
 *
 *  Final check is that users has to go step by step even if they jumped back
 */
export function stepGuard(step: number): CanActivateFn {
  // oxlint-disable-next-line max-statements
  return () => {
    const router = inject(Router);
    const tiiaß = inject(TiiaService);
    const { location } = globalThis;
    const path = location.pathname.replace('/', '');
    const finalPath = router.config[5]?.path || '';
    const paymentPath = router.config[4]?.path || '';
    const currentNavigation = router.currentNavigation();
    const authß = inject(TiiaAuthService);

    if (init) {
      const urlParams = new URLSearchParams(location.search);
      const referralCode = urlParams.get('referralCode') || 'KP_WEB';

      tiiaß.updateModel(
        'additionalAgreementInfo.referralCode',
        referralCode.toUpperCase() as 'ALD_WEB' | 'KB_WEB' | 'KP_WEB',
      );

      if (step === 5) {
        authß.checkSession();
      }

      // eslint-disable-next-line @smarttools/rxjs/no-ignored-subscribe
      authß.login(false, referralCode?.toUpperCase().split('_')[0]).subscribe();
    }

    if (
      step < 4 &&
      currentNavigation?.previousNavigation?.extractedUrl.root.children[
        'primary'
      ]?.segments[0]?.path === paymentPath &&
      currentNavigation.extractedUrl.root.children['primary']?.segments[0]
        ?.path !== paymentPath
    ) {
      return router.parseUrl(`/${paymentPath}`);
    }

    if (init && !(step === 5 && path === finalPath) && path !== '') {
      init = false;

      return router.parseUrl('');
    }

    const prevPath = router
      .currentNavigation()
      ?.previousNavigation?.finalUrl?.toString()
      .replace('/', '')
      // Regex because we want to remove event query params after `/`
      // eslint-disable-next-line prefer-named-capture-group
      .replace(/\?(.*)/u, '');
    const prevStep = router.config.findIndex(r => r.path === prevPath);

    if (
      step > prevStep &&
      step - 1 !== prevStep &&
      !(step === 5 && prevStep === -1)
    ) {
      return router.parseUrl(router.config[prevStep + 1]?.path || '');
    }

    tiiaß.setStep(step);

    init = false;

    return true;
  };
}
